import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class PdrsService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.filemanager = new FileManager()
  }

  async getAllItemsForMindTable(opts = {}){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/pdrs/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  async deleteConsumoGas(idPdr, idConsumoGas){
    let success = false

    const url = `${this.baseUrl}/pdrs/${idPdr}/consumoGas/${idConsumoGas}`
    try {
      let res = await this.http.delete(url)
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-load')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async updateConsumoGas(consumoAggiornato) {
    let item = {};
    const url = `${this.baseUrl}/pdrs/consumoGas/modifica`;
  
    try {

        const res = await this.http.post(url, { obj: consumoAggiornato });

        if (res.data.success) {
            item = res.data.updatedData;
        } else {
            throw new Error("Aggiornamento fallito");
        }
    } catch (err) {
        console.error("Errore durante l'aggiornamento:", err.message);
        this.eventBus.emit('data-load-error', { message: err.message, url });
    } finally {
        this.eventBus.emit('data-loaded');
    }

    return { item };
}

  async updateLettura(data) {
    const url = `${this.baseUrl}/pdrs/letture/modifica`; 
    try {
      const response = await this.http.put(url, data);  
      return response.data;
    } catch (error) {
      console.error("Errore durante l'aggiornamento del consumo:", error);
      throw error;
    }
  }

  getAllColumnsForMindTable(){
    return [
      {
        property: 'code',
        label: 'Codice',
        // type: {
        //   isBoolean:true
        //   isCurrency:true
        //   isDate: true
        // },
        sortable: true,
        default: true,
      },
      {
        property: 'cc',
        label: 'CC',
        default: true,
      },
      {
        property: 'udd',
        label: 'UDD',
        default: true,
      },
      {
        property: 'data_inizio',
        label: 'Data Inizio',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'data_fine',
        label: 'Data Fine',
        type: {
          isDate: true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'classe',
        label: 'Classe',
        default: true,
      },
      {
        property: 'categoria_uso',
        label: 'Categoria Uso',
        sortable: true,
      },
      {
        property: 'spedizione',
        label: 'Spedizione',
      },
      // {
      //   property: 'saldo',
      //   label: 'Saldo',
      //   type: {
      //     isCurrency:true
      //   },
      //   default: true,
      // },
      {
        property: 'consumo_annuo',
        label: 'Consumo Annuo',
        default: true,
      },
      {
        property: 'remi',
        label: 'Remi',
        sortable: true,
        default: true,
      },
      {
        property: 'disalimentabile',
        label: 'Disalimentabile',
        type: {
          isYorN:true
        },
        sortable: true,
        default: true,
      },
      {
        property: 'stato',
        label: 'Stato',
        sortable: true,
        default: true,
      },
      {
        property: 'uso',
        label: 'Uso',
        sortable: true,
        default: true,
      },
      {
        property: 'piva',
        label: 'Partita Iva',
        default: true,
      },
      {
        property: 'codfis',
        label: 'Codice Fiscale',
        default: true,
      },
      {
        property: 'cliente',
        label: 'Cliente',
        sortable: true,
        default: true,
      },
      {
        property: 'type_client',
        label: 'Tipo Cliente',
        sortable: true,
        default: true,
      },
      {
        property: 'rappresentante',
        label: 'Rappresentante',
        sortable: true,
        default: true,
      },
      {
        property: 'comune',
        label: 'Comune',
        sortable: true,
        default: true,
      },
      {
        property: 'indirizzo',
        label: 'Indirizzo',
        default: true,
      },
      {
        property: 'fornitura_toponimo',
        label: 'Toponimo (s)',
      },
      {
        property: 'fornitura_indirizzo',
        label: 'Indirizzo (s)',
      },
      {
        property: 'fornitura_civico',
        label: 'Civico (s)',
      },
      {
        property: 'provincia',
        label: 'Provincia',
        default: true,
      },
      {
        property: 'cap',
        label: 'Cap',
        default: true,
      },
      {
        property: 'email',
        label: 'Email',
        default: true,
      },
      {
        property: 'contratto',
        label: 'Contratto',
        default: true,
      },
      {
        property: 'data_inizio_contratto',
        label: 'Data inizio Contratto',
        type: {
          isDate: true
        },
      },
      {
        property: 'agente',
        label: 'Agente',
        sortable: true,
        default: true,
      },
      {
        property: 'periodo_fatturazione',
        label: 'Periodo Fatturazione',
        sortable: true,
      },
      {
        property: 'pagamento',
        label: 'Pagamento',
        sortable: true,
      },
      {
        property: 'offerta',
        label: 'Offerta',
        sortable: true,
        default: true,
      },
      {
        property: 'iva',
        label: 'Iva (%)',
        sortable: true,
        default: true,
      },
      {
        property: 'stato_interno',
        label: 'Stato interno',
        sortable: true,
      },
      {
        property: 'data_stato_interno',
        label: 'Data Stato interno',
        type: {
          isDate: true
        },
        sortable: true,
      },
      {
        property: 'pratica',
        label: 'Pratica',
        sortable: true,
      },
      {
        property: 'cod_pratica_provider',
        label: 'Code Pratica',
        sortable: true,
      },
      {
        property: 'esito',
        label: 'Esito',
        sortable: true,
      },
      {
        property: 'motivazione_esito',
        label: 'Motivazione Esito',
        sortable: true,
      },
      {
        property: 'data_esito',
        label: 'Data Esito',
        type: {
          isDate: true
        },
        sortable: true,
      },
      {
        property: 'banca',
        label: 'Banca RID',
        sortable: true,
      }
    ]
  }

  async getPraticheFornitori(pdrId) {
    let item = {
      fornitori: [],
      pratiche: [],
      pratiche_gestione: [],
    }

    const url = `${this.baseUrl}/pdrs/${pdrId}/pratiche/fornitori`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data || item
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
      }
    }
  }

  async getDettaglioPdr(id){
    let item = {}

    const url = `${this.baseUrl}/pdrs/${id}`
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data || {}

      item.preview_fattura = res.preview_fattura || item.preview_fattura || []
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async updateInfo(id, info){
    let item = {}
    let success = false

    const url = `${this.baseUrl}/pdrs/${id}/info`
    try {
      let res = await this.http.put(url, {data: info})
      res = res.data

      item = res.data
      success = res.meta.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

  async downloadLettura(id){

    const url = `${this.baseUrl}/pdrs/letture/download/${id}`
    try {
      let res = 
      await this.http({
          url,
          method: 'GET',
          responseType: 'blob',
        })

      this.filemanager.download(res)
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }

  }

  async riusaLettura(id){
    let item = {}

    const url = `${this.baseUrl}/pdrs/letture/riusa/${id}`
    try {
      let res = await this.http.get(url)

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }


  async eliminaLettura(id){
    let item = {}

    const url = `${this.baseUrl}/pdrs/letture/elimina/${id}`
    try {
      let res = await this.http.get(url)

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }


  async updateCoeffLettura(obj){
    let item = {}

    const url = `${this.baseUrl}/pdrs/letture/coefficente/modifica`
    try {
      let res = await this.http.post(url, {obj})

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async getLetture(pdrId){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/pdrs/${pdrId}/letture`
    try {
      let res = await this.http.get(url)
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems
      }
    }
  }

  async addNewLettura(obj){
    let item = {}

    const url = `${this.baseUrl}/pdrs/lettura/create`
    try {
      let res = await this.http.post(url, {obj})

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async getDatiRcuGas(pdrId) {
    let items = {
      dati_gas: []
    }
  
    const url = `${this.baseUrl}/AreaFlussi/caricamento-flows/getDatiRcuGas`
    try {
      let res = await this.http.get(url, {
        params: {
          pdr_id: pdrId
        }
      })
      res = res.data
  
      if (res.status === 'success') {
        items = res.data
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return items
    }
  }

  async getCaricamentiWizardByCode(code) {
    let items = []
    let success = false

    const url = `${this.baseUrl}/pdrs/caricamenti-wizard-by-code`
    try {
      let res = await this.http.post(url, { code })
      res = res.data

      if (Array.isArray(res)) {
        items = res
        success = true
      } else if (Array.isArray(res.data)) {
        items = res.data
        success = res.meta?.success ?? res.success ?? true
      } else if (Array.isArray(res.items)) {
        items = res.items
        success = res.meta?.success ?? res.success ?? true
      } else if (res.data && typeof res.data === 'object') {
        items = [res.data]
        success = res.meta?.success ?? res.success ?? true
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        success,
      }
    }
  }

  async deleteMensilitaRealeGas(idPdr, idMensilita){
    let success = false

    const url = `${this.baseUrl}/pdrs/${idPdr}/mensilita-reali/${idMensilita}/disable`
    try {
      let res = await this.http.post(url)
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-load')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

async riusaMensilitaRealeGas(idPdr, idMensilita){
    let success = false

    const url = `${this.baseUrl}/pdrs/${idPdr}/mensilita-reali/${idMensilita}/riusa`
    try {
      let res = await this.http.post(url)
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-load')

      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

async mensilitaRealeUsed2Gas(idPdr, idMensilita){
    let success = false

    const url = `${this.baseUrl}/pdrs/${idPdr}/mensilita-reali/${idMensilita}/used2`
    try {
      let res = await this.http.post(url)
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-load')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async setRapidCheckFatturabile(row) {
    let success = false
    let data = null

    const url = `${this.baseUrl}/pdrs/fatturabile/rapid-check`

    try {
      let res = await this.http.post(url, {
        id: row.id,
        cod_pdr: row.cod_pdr,
        mese: row.mese,
        inizio: row.inizio,
        fine: row.fine,
      })
      res = res.data

      success = res.data?.success ?? res.meta?.success ?? false
      data = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        success,
        data,
      }
    }
  }

  async updateMensilitaFatturabile(row) {
    let success = false
    let updatedRecords = []

    const url = `${this.baseUrl}/pdrs/update-fatturabile`
    try {
      let res = await this.http.post(url, {
        id: row.id,
        cod_pdr: row.cod_pdr,
        mese: row.mese,
        inizio: row.inizio,
        fine: row.fine,
      })
      res = res.data

      success = res.data?.success ?? false
      updatedRecords = res.data?.updated_records || []
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        success,
        updatedRecords,
      }
    }
  }

  async changeDataFineContrattoVendita(idPdr, codContratto, dataFine) {
    let success = false
    let data = null
    let message = null
    let validate = null

    const url = `${this.baseUrl}/pdrs/${idPdr}/contratti/vendita/data-fine`

    try {
      let res = await this.http.put(url, {
        cod_contratto: codContratto,
        data_fine: dataFine,
      })
      res = res.data

      success = res.meta?.success ?? false
      data = res.data
      message =
        res.message ||
        res.errors?.message ||
        res.meta?.errors?.message ||
        res.meta?.status?.message ||
        res.meta?.message ||
        null
      validate = res.meta?.validate || res.validate || null
    } catch (err) {
      const errData = err.response?.data
      if (errData) {
        success = errData.meta?.success ?? false
        message =
          errData.message ||
          errData.errors?.message ||
          errData.meta?.errors?.message ||
          errData.meta?.status?.message ||
          errData.meta?.message ||
          null
        validate = errData.meta?.validate || errData.validate || null
      }
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')

      // eslint-disable-next-line no-unsafe-finally
      return {
        success,
        data,
        message,
        validate,
      }
    }
  }

}
